<router-outlet></router-outlet>

<!--<a class="small" routerLink="/login">Iniciar!</a><br/>
<a class="small" routerLink="/panel">Panel!</a>-->
Página web en construccion...
